import React, { Suspense, lazy } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import SupplierLogin from "../pages/Supplier/SupplierLogin";
import AdminLogin from "../pages/Admin/AdminLogin";
import SupplierDashboardOutlet from "../pages/Home/supplierHome/DashboardOutlet";
import AdminDashboardOutlet from "../pages/Home/adminHome/DashboardOutlet";
import LoginOutlet from "../pages/Home/supplierHome/LoginOutlet";
import UserType from "../pages/UserTypeSelection/UserType";
import SignUp from "../pages/Supplier/SignUp";
import Goals from "../pages/Supplier/supplierGoals/Goals";
import DashBoard from "../pages/Supplier/supplierDashboard/DashBoard";
import AdminDashBoard from "../pages/Admin/AdminDashBoard";
import SupplierSearch from "../pages/Admin/SupplierSearch";
import GetStartedPage from "../pages/Home/GetStartedPage";
import DashboardOutlet from "../pages/Supplier/supplierDashboard/DashboardOutlet";
import SupplierForm from "../pages/Supplier/SupplierForm";
import DetailView from '../components/KpiDetailView/DetailView';
import Reporting from "../pages/Supplier/Reporting";
import CdpReporting from "../pages/Supplier/reporting/reporting";
import Navigation from "../pages/index"
import ProtectedLoginRoute from "../components/common/Login/ProtectedLoginRoute";
import Signup from "../pages/Home/SignupOutlet";
import ProfilePage from "../pages/Admin/ProfilePage";
import EntityManagement from "../pages/Admin/EntityManagement";
import RolesAndPermissions from "../pages/Admin/RolesAndPermissions";
import { Outlet, Navigate } from 'react-router-dom';
import ProtectedSupplierAdminRoute from "../pages/Admin/ProtectedSupplierAdminRoute";

//submodule
import {subRoute} from '../gitsubmodules/onboarding/src/routes/Path';
import {subRoute1} from '../gitsubmodules/trackon/src/routes/Path'; // SubApp routes
import ViewEntries from "../pages/LogBook/ViewEntries";
import EmployeeEditEntry from "../pages/LogBook/EmployeeEditEntry";
import EmployeeProcessManagement from "../pages/LogBook/EmployeeProcessManagement";
import LogBookOutlet from "../pages/LogBook/LogBookOutlet";
import LogBookLoginOutlet from "../pages/LogBook/LogBookLoginOutlet";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigation />,
  },
  {
    path: "/sustainability-home",
    element: <GetStartedPage />,
  },
  {
    path: "/",
    element: <LoginOutlet />,
    children: [
      {
        path: "/userType",
        element: (
          <ProtectedLoginRoute>
            <UserType />
          </ProtectedLoginRoute>
       ),
      },
      {
        path: "/supplierLogin",
        element: (
          <ProtectedLoginRoute>
            <SupplierLogin />
          </ProtectedLoginRoute>
       ),
      },
      {
        path: "/adminLogin",
        element: (
          <ProtectedLoginRoute>
            <AdminLogin />
          </ProtectedLoginRoute>
        ),
      },
    ],
  },
 
  {
    path: "/signup",
    element: <Signup />,
  },
  
  {
    path: "/admin",
    element: <AdminDashboardOutlet />,
    handle: { breadcrumb: "Dashboard" },  
    children: [
      { 
        index: true, 
        element: <AdminDashBoard />, 
       
      },
      { 
        path: "dashboard", 
        element: <AdminDashBoard />, 
       
      },
      { 
        path: "suppliersearch", 
        element: null, 
        handle: { breadcrumb: "Supplier Search" } ,
        children: [
          { 
            index: true, 
            element: <SupplierSearch />, 
           
          },
          {
            path:"profile/:companyName",
            element:<ProfilePage/>,
            handle: { breadcrumb: "Profile" } 
          },
        ]
      },
      { 
        path: "detailedview", 
        element: <DetailView />, 
        handle: { breadcrumb: "Detailed View" } 
      },
      {
        path: "roles-permissions",
        element: <Outlet />, 
        handle: { breadcrumb: null },
        children: [ 
          {
            path: "entities",
            element: <EntityManagement />,
            handle: { breadcrumb: "Entities" },
          },
          {
            path: "permissions",
            element: <RolesAndPermissions />,
            handle: { breadcrumb: "Roles & Permissions" },
          }
        ]
      }
      
    ],
},


  {
    path: "/supplier",
    element: <SupplierDashboardOutlet />,
    children: [
      {
        path: "",
        element: <DashboardOutlet />,
        handle: { breadcrumb: "Dashboard" },
        children: [
          {
            path:"",
            element: <DashBoard />,
            handle: { breadcrumb: "" },
          },
          {
            path:'detailedview',
            element: <DetailView />,
            handle: { breadcrumb: "Detailview" },
          },
        ],

      },
      {
        path: "dashboard",
        element: <DashboardOutlet />,
        handle: { breadcrumb: "Dashboard" },
        children: [
          {
            path:'',
            element: <DashBoard />,
            handle: { breadcrumb: "" },
          },
          {
            path:'kpidetailview',
            element: <DetailView />,
            handle: { breadcrumb: "Detailview" },
          },
        ],
      },
      { 
        path: "goals", 
        element: <Goals />,     
        handle: { breadcrumb: "Goals" } 
      },
      {
        path: "reporting",
        element: <Reporting/>,
        // element:<CdpReporting/>,
        handle: { breadcrumb: "Reporting" },
      },
     
    ],
  },
  {
    path:"/logbook/login",
    element:<LogBookLoginOutlet/>
  },

  {
    path:"/logbook",
    element:<LogBookOutlet/>,
    children:[
      {
        path:"view-entries",
        element:<ViewEntries/>
      },
      {
        path: "employee-process-management",
        element: (
            <EmployeeProcessManagement />
        )
      },
      {
        path: "edit-employee/:id",
        element:<EmployeeEditEntry />
      }
    ]
  },
  {
    path: '/subapp',
    children: subRoute, // Nest SubApp routes under /subapp
  },
   {
    path: '/watchtower',
    children: subRoute1, // Nest SubApp routes under /watchtower
  }
]);
 
function Path() {
  return <RouterProvider router={router} />;
}


export default Path;